import { RectangleGroupIcon } from '@heroicons/react/24/outline'

import Breadcrumb from '@/components/navigation/Breadcrumb'

import { FiltersRow } from './filters/FiltersRow'
import { columns } from './table/Columns'
import { DataTable } from './table/DataTable'
import { TableContextProvider } from './table/TableContext'
import {
  LogisticContainerProvider,
  useLogisticContainer,
} from './hooks/useLogisticContainer'
import ContainerWizard from './wizzardContainer/ContainerWizard'

function ContainerListContent() {
  const { editContainer, showNewContainer, onCloseWizard } =
    useLogisticContainer()

  return (
    <div>
      <Breadcrumb
        icon={<RectangleGroupIcon className="h-6 text-gray-500" />}
        paths={[{ name: 'Logística' }, { name: 'Contenedores' }]}
      />
      <FiltersRow />
      <TableContextProvider>
        <DataTable columns={columns} />
      </TableContextProvider>
      <ContainerWizard
        editContainer={editContainer}
        onClose={onCloseWizard}
        showState={showNewContainer}
      />
    </div>
  )
}

export default function ContainerList() {
  return (
    <LogisticContainerProvider>
      <ContainerListContent />
    </LogisticContainerProvider>
  )
}
